module.exports = __webpack_public_path__ + "img/weixin.d21da380.png";